import { useEffect } from 'react'
import { useRouterState } from '@tanstack/react-router'
import { trackVirtualPageview } from '@/lib/track'

export function usePageTracking(): void {
  const routerState = useRouterState()
  const pathname = routerState.location.pathname

  useEffect(() => {
    trackVirtualPageview(pathname, document.title)
  }, [pathname])
}
